/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react"
import { T営業所 } from "../../service/master/eigyosyo/TEigyosyo"
import { defaultComboBoxTextFormatter } from "../../ts/util/commonUtil"
import BaseComboBox, { TExtendedBaseComboBoxProps } from "./BaseComboBox"

//TODO:ダミー用に配置
export type T営業所マスタ = T営業所

// コンボボックスでの表示対象となるアイテムの型定義をここに記載
type TItem = T営業所マスタ & { name?: string }

const displayNameProperty: keyof TItem = "name"
// コンボボックスの表示名とするプロパティ名
const displayField: keyof TItem = "営業所名"
// 表示名のデフォルトフォーマッタ
const defaultDisplayTextFormatter = defaultComboBoxTextFormatter

// コンボボックスの選択値となるプロパティ名
const valueField: keyof TItem = "営業所コード"

// 全選択の選択用アイテム生成処理
const createAllSelectItem = () => {
  const obj = {} as TItem
  // 全選択の表示名
  obj[displayField] = `すべて`
  // 全選択時の値
  obj[valueField] = ""
  return obj
}

// 未選択用のアイテム生成処理
const createEmptyItem = () => {
  const obj = {} as TItem
  // 全選択の表示名
  obj[displayField] = ``
  // 全選択時の値
  obj[valueField] = ""
  return obj
}

/**
 *
 * @param props
 * @returns
 */
export const EigyosyoComboBox: React.FC<
  TExtendedBaseComboBoxProps<string, T営業所マスタ>
> = (props) => {
  // state
  const [innerItemsSource, setInnerItemsSource] = useState<Array<TItem>>([])

  // nameプロパティ追加処理
  const appendNameProperty = (data: TItem[]) => {
    // any型で処理することで name プロパティを追加
    data.forEach((value: TItem) => {
      value[displayNameProperty] = props.displayTextFormatter
        ? props.displayTextFormatter(value)
        : defaultDisplayTextFormatter(value, valueField, displayField)
    })
  }

  // 初期値がある場合の設定処理
  const setDefaultValue = (data: TItem[]) => {
    if (props.defaultValue) {
      const firstData = data.find((d) => {
        return d[valueField] === props.defaultValue
      })
      if (firstData != null) {
        props.setText && props.setText(firstData[displayNameProperty] ?? "")
        props.setSelectedItem && props.setSelectedItem(firstData)
        props.setSelectedValue && props.setSelectedValue(firstData[valueField])
      }
    }
  }
  // itemsSource更新時に選択Itemを先頭のitemに変更
  const setFirstValue = (data: TItem[]) => {
    const firstData = data.length > 0 ? data[0] : undefined
    if (firstData != null) {
      props.setText && props.setText(firstData[displayNameProperty] ?? "")
      props.setSelectedItem && props.setSelectedItem(firstData)
      props.setSelectedValue && props.setSelectedValue(firstData[valueField])
    }
  }
  // 初期設定
  useEffect(() => {
    // itemsSource検索開始フラグ
    if (
      props.itemsSource != null &&
      props.ComboBox != null &&
      props.isLoadEnded === false
    ) {
      const data = (props.itemsSource ?? []).filter(
        props.listFilter ? props.listFilter : () => true
      )
      if (props.isAllSelect) {
        data.splice(0, 0, createAllSelectItem())
      } else if (props.isEmpty) {
        data.splice(0, 0, createEmptyItem())
      }

      // デフォルトラベルを設定
      appendNameProperty(data)
      setInnerItemsSource(data)
      setDefaultValue(data)

      props.setIsLoadEnded(true)
    }
  }, [props.itemsSource, props.ComboBox, props.isLoadEnded])

  // itemsSource更新時
  useEffect(() => {
    if (
      props.itemsSource != null &&
      props.ComboBox != null &&
      props.isLoadEnded
    ) {
      const data = (props.itemsSource ?? []).filter(
        props.listFilter ? props.listFilter : () => true
      )
      if (props.isAllSelect) {
        data.splice(0, 0, createAllSelectItem())
      } else if (props.isEmpty) {
        data.splice(0, 0, createEmptyItem())
      }

      appendNameProperty(data)
      setInnerItemsSource(data)
      // データを更新
      setFirstValue(data)
    }
  }, [props.itemsSource])

  // 必要項目を渡したBaseComboBoxを返却
  return (
    <>
      <BaseComboBox
        displayField={displayNameProperty}
        valueField={valueField}
        {...props}
        itemsSource={innerItemsSource}></BaseComboBox>
    </>
  )
}
